const FormLabel = {
    baseStyle: {
        color: "pureWhite",
        fontSize: 16,
        fontFamily: 'RoobertTrial'
    }
}

export default FormLabel